var _rect, _path, _path2, _path3, _path4, _path5, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGooglePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.763 25.88v-4.891h2.524c1.035 0 1.908-.347 2.62-1.03l.17-.174a3.521 3.521 0 00-.17-4.93 3.603 3.603 0 00-2.62-1.049h-4.052V25.88h1.528zm0-6.374V15.29h2.563c.55 0 1.072.212 1.462.597.825.809.844 2.157.047 2.994-.389.414-.94.645-1.51.626h-2.562zm12.442-1.242c-.655-.606-1.547-.915-2.677-.915-1.452 0-2.543.54-3.264 1.608l1.347.857c.494-.732 1.168-1.097 2.022-1.097.54 0 1.063.202 1.47.568.4.346.627.847.627 1.377v.356c-.588-.328-1.328-.5-2.24-.5-1.062 0-1.916.25-2.552.76-.636.51-.959 1.184-.959 2.04a2.57 2.57 0 00.902 2.023c.598.539 1.357.809 2.249.809 1.053 0 1.888-.472 2.524-1.416h.067v1.146h1.461v-5.093c0-1.069-.323-1.916-.977-2.523zm-4.147 6.095a1.256 1.256 0 01-.503-1.011c0-.453.209-.828.617-1.127.417-.298.94-.452 1.556-.452.855-.01 1.519.183 1.993.568 0 .655-.256 1.223-.759 1.704a2.41 2.41 0 01-1.718.722 1.85 1.85 0 01-1.186-.404zm8.408 5.15l5.105-11.89h-1.66l-2.363 5.931h-.029l-2.42-5.93h-1.66l3.35 7.73-1.899 4.16h1.576z",
    fill: "#3C4043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.488 19.93a8.69 8.69 0 00-.114-1.407H14.93v2.667h3.692a3.214 3.214 0 01-1.366 2.109v1.733h2.201c1.29-1.204 2.031-2.985 2.031-5.103z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.93 26.708c1.842 0 3.398-.616 4.528-1.675L17.256 23.3c-.617.423-1.405.664-2.325.664-1.784 0-3.293-1.223-3.834-2.86H8.829v1.791a6.815 6.815 0 006.102 3.813z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.097 21.105a4.24 4.24 0 010-2.658v-1.781H8.828a6.962 6.962 0 000 6.22l2.269-1.781z",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.93 15.587a3.649 3.649 0 012.62 1.04l1.955-1.983a6.543 6.543 0 00-4.574-1.8c-2.581 0-4.945 1.482-6.102 3.822l2.268 1.79c.54-1.646 2.05-2.869 3.834-2.869z",
    fill: "#EA4335"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "#F2F4F7"
  })));
}

export default SvgIconGooglePay;